import Axios from "axios";
import {
    SET_BRAND_LIST,
    UNSET_BRAND_LIST,
  } from "@/store/mutation-types";
import { saveUpdateBrand, getBrandList, generateBrandCode } from "@/store/api";
// initial state
const state = {
  getBrandList: [],
};

const getters = {
  getBrandList(state) {
    return state.getBrandList;
  },
};

const mutations = {
  [SET_BRAND_LIST](state, data) {
    state.getBrandList = data;
  },
  [UNSET_BRAND_LIST](state) {
    state.getBrandList = [];
  },

};

const actions = {

  saveUpdateBrand({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateBrand, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {

          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

  getBrandList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(getBrandList, data)
        .then(function (response) {
          commit('SET_BRAND_LIST', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_BRAND_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },

  getGeneratedBrandCode({ commit }) {
    return new Promise((resolve, reject) => {
      Axios.get(generateBrandCode)
        .then((response) => {
          resolve(response.data.code);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },


};

export default {
  state,
  getters,
  actions,
  mutations,
};
